/*
 This file is part of GNU Taler
 (C) 2022-2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

/**
 * Imports.
 */
import { HttpLib, HttpLibArgs } from "@gnu-taler/taler-util/http";
import { browserRawLib } from "./http-impl.browser.js";

/**
 * The HTTP request library for the browser.
 *
 * Everything except moving the bytes lives in HttpLib, shared with the node
 * and qtart backends; this only binds it to the browser's fetch API.
 */
export class BrowserFetchHttpLib extends HttpLib {
  public constructor(args?: HttpLibArgs) {
    super(browserRawLib, args);
  }
}
